import styled from "styled-components";

export const LayoutContainer = styled.div`
  padding: 60px 20px;
  background-color: rgba(0, 0, 0, 0.5);
  inset: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  z-index: 100;

  .card{
    min-width: 300px;
    max-width: calc(100vw - 40px);
    border-radius: 24px;
    position: relative;

    button.btn_clear{
      width: 36px;
      height: 36px;
      padding: 0;
      border: none;
      background-color: #222;
      mask: url(/images/clear.png) no-repeat center center / 12px 12px;
      position: absolute;
      top: 11px;
      right: 12px;
    }

    
    &_top{
      padding: 20px 24px;

      + .card_middle{
        padding: 20px 24px;
        /* border-top: 1px solid #eee; */
      }
    }

    &_middle{
      &:nth-of-type(1){
        padding: 48px 24px;
      }
      /* + .card_bottom{
        border-top: 1px solid #eee;
      } */
    }

    &_bottom{
      padding: 20px 24px;
      button{
        min-width: 140px;
        height: 45px;
        border: none;
        border-radius: 6px;
        + button{
          margin-left: 20px;
        }
      }
    }
  }

/* 
display: flex;
-webkit-box-align: center;
align-items: center;
-webkit-box-pack: center;
justify-content: center;
inset: 0px;
-webkit-tap-highlight-color: transparent;
z-index: -1; */

/*     
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0; */

  /* position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 400px;
    background-color: rgb(18, 18, 18);
    border: 2px solid rgb(0, 0, 0);
    box-shadow: rgb(0 0 0 / 20%) 0px 11px 15px -7px, rgb(0 0 0 / 14%) 0px 24px 38px 3px, rgb(0 0 0 / 12%) 0px 9px 46px 8px;
    padding: 32px; */

  


  @media screen and (min-width: 501px) {
  }
  
  @media (max-width: 500px) {
    .card {
      width: 100%;
    }
  }
`